import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OverviewApiClient extends MoovementApiClient {


  download(overviewRequest:{ farmId: string, capabilities: string[]  }): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/api/overview`, overviewRequest, {
      headers: {
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    });
  }

}
